import StyledLink from '../StyledLink'
import makeQueryString from './makeUrl/makeUrl'
import {
  ASSETS,
  DUPLICATE,
  EDIT,
  SPACES,
  SUITES
} from '../routes'

interface Params {
  importTo?: string
}

interface Props {
  children: React.ReactNode
  spaceId: string
  suiteId: string
}

const LinkToDuplicateSpaceAssetsInternalStorageSuites = ({
  children,
  spaceId,
  suiteId,
  ...params
}: Props & Params) => {
  const url = `/${SPACES}/${spaceId}/${ASSETS}/${EDIT}/${SUITES}/${suiteId}/${DUPLICATE}`

  return (
    <StyledLink to={makeQueryString(url, { ...params })}>
      {children}
    </StyledLink>
  )
}

export default LinkToDuplicateSpaceAssetsInternalStorageSuites
